export default "__VITE_ASSET__BKnCrBgr__"